import React, { useEffect, useState } from "react";
import { Container, Typography, Grid, CircularProgress } from "@mui/material";
import HomeCard from "../Component/HomeCard/HomeCard";
import VideoCorousel from "../Component/VideoCorousel/VideoCorousel";
import axios from "axios";
import { useParams } from "react-router-dom";

const DesignSection = () => {
  const { category } = useParams();
  const [designs, setDesigns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDesigns = async () => {
      try {
        const res = await axios.get(`https://urbancasabackendfiles.onrender.com/api/projects?category=${category}`);
        setDesigns(res.data);
      } catch (error) {
        console.error(`Error fetching ${category} designs:`, error);
      } finally {
        setLoading(false);
      }
    };

    fetchDesigns();
  }, [category]);

  return (
    <div>
      <VideoCorousel />
      <Container maxWidth="xl" style={{ padding: "40px" }}>
        <Typography variant="h3" align="center" gutterBottom>
          {category.replace(/([A-Z])/g, " $1").trim()} {/* Example: CommunityDesign → Community Design */}
        </Typography>

        {loading ? (
          <div style={{ textAlign: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          <Grid container spacing={4}>
            {designs.map((home, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <HomeCard home={home} />
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </div>
  );
};

export default DesignSection;
